var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as dayjs from 'dayjs';
import Button from '@/common/components/Button/index2.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DateRange from '../DateRange/index.vue';
import StatusSelect from './components/StatusSelect.vue';
import OccupySelect from './components/OccupySelect.vue';
// import ShopSelect from './components/ShopSelect/index.vue';
import ShopSelect from './components/ShopSelect.vue';
import SpotSelect from './components/SpotSelect.vue';
import CategorySelect from './components/CategorySelect.vue';
import TagSelect from './components/TagSelect.vue';
import CitySelect from './components/CitySelect.vue';
import SupplierSelect from './components/SupplierSelect.vue';
import MetroLineSelect from './components/MetroLineSelect.vue';
import AddClueModal from '../AddClueModal/index.vue';
import { deepCopy, isArray } from '@lhb/func';
import { getStorage } from '@lhb/cache';
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.searchParams = {
            statuses: [],
            occupationStatus: '',
            period: 'DAY',
            startDate: dayjs().format('YYYY-MM-DD'),
            endDate: dayjs().add(14, 'day').format('YYYY-MM-DD'),
            year: '',
            tenantPlaceIdList: [],
            categoryIds: [],
            cityIdList: [],
            labelIdList: [],
            tenantSpotIdList: [],
            metroIdList: [],
            supplierIdList: [],
        };
        _this.showMoreFilter = false;
        _this.pattern = 1;
        _this.showSupplierSelect = false;
        _this.showMetroLineSelect = false;
        return _this;
    }
    Object.defineProperty(Search.prototype, "dropdowns", {
        get: function () {
            return [
                { name: '到期提醒', command: 'alert', num: this.alertNum },
                { name: '分享', command: 'share' },
                { name: '导出', command: 'export' },
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Search.prototype, "user", {
        get: function () {
            return this.$store.state.common.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Search.prototype, "storeParams", {
        get: function () {
            return this.$store.getters['getScheduleSearchParams'];
        },
        enumerable: false,
        configurable: true
    });
    Search.prototype.mounted = function () {
        this.init();
    };
    Search.prototype.companyChange = function (newVal, oldVal) {
        if ((newVal === null || newVal === void 0 ? void 0 : newVal.companyId) !== (oldVal === null || oldVal === void 0 ? void 0 : oldVal.companyId)) {
            this.init();
        }
    };
    /* method */
    Search.prototype.init = function () {
        // const scheduleFilter = getStorage('scheduleFilter');
        // if (scheduleFilter.placeName) {
        //   this.searchParams = scheduleFilter.placeName;
        // }
        var _a, _b, _c, _d, _e;
        if (this.storeParams.statuses) {
            this.searchParams.statuses = this.storeParams.statuses;
        }
        if (this.storeParams.occupationStatus) {
            this.searchParams.occupationStatus = this.storeParams.occupationStatus;
        }
        var _f = this.storeParams, _g = _f.categoryIds, categoryIds = _g === void 0 ? [] : _g, _h = _f.cityIdList, cityIdList = _h === void 0 ? [] : _h, _j = _f.labelIdList, labelIdList = _j === void 0 ? [] : _j;
        this.searchParams = __assign(__assign({}, this.searchParams), { tenantPlaceIdList: [], tenantSpotIdList: [], categoryIds: categoryIds,
            cityIdList: cityIdList,
            labelIdList: labelIdList });
        if (((_b = (_a = this.$refs) === null || _a === void 0 ? void 0 : _a.dateRange) === null || _b === void 0 ? void 0 : _b.handlePattern) instanceof Function) {
            (_e = (_d = (_c = this.$refs) === null || _c === void 0 ? void 0 : _c.dateRange) === null || _d === void 0 ? void 0 : _d.handlePattern) === null || _e === void 0 ? void 0 : _e.call(_d, this.pattern, true);
        }
        this.showSupplierSelect = getStorage('hasContactTab');
        this.showMetroLineSelect = getStorage('hasMetroLine');
    };
    Search.prototype.handleMetroIds = function (values) {
        var res = [];
        if (!isArray(values))
            return [];
        values.map(function (item) {
            if (item.includes(',')) {
                var arr = item.split(',');
                res = __spreadArrays(res, arr);
            }
            else {
                res.push(item);
            }
        });
        return res;
    };
    Search.prototype.loadData = function () {
        var searchParams = deepCopy(this.searchParams);
        console.log(searchParams, 'supplierSearch');
        var _a = searchParams.labelIdList, labelIdList = _a === void 0 ? [] : _a, _b = searchParams.cityIdList, cityIdList = _b === void 0 ? [] : _b;
        var _handleMetroIds = this.handleMetroIds;
        this.$emit('loadData', __assign(__assign({}, searchParams), { labelIdList: labelIdList, cityIdList: cityIdList.length ? cityIdList.flat(2) : [], metroIdList: _handleMetroIds && _handleMetroIds(searchParams.metroIdList) }));
    };
    Search.prototype.updateParamsStore = function (params) {
        this.$store.commit('UPDATE_SCHEDULE_SEARCH_PARAMS', __assign({}, params));
    };
    Search.prototype.statusChangeHandle = function (val) {
        var uuid = 'e4f7b5b7-d461-42fe-b0d4-6466821cc712';
        switch (val) {
            case 'INTENTION':
                uuid = '6829f5ac-7bae-473e-bf53-df863da76210';
                break;
            case 'PRE_LOCK':
                uuid = 'e32e954c-f565-4757-b495-34fc56a41e1b';
                break;
            case 'SUCCESS':
                uuid = 'd3a60aa5-5399-417b-9254-49f84750090a';
                break;
            default:
                break;
        }
        window.LHBbigdata.send({
            event_id: uuid
        });
        this.updateParamsStore({
            statuses: val,
        });
        this.loadData();
    };
    Search.prototype.occupyChangeHandle = function (val) {
        var uuid = '';
        switch (val) {
            case 'ALL_VACANT':
                uuid = 'aa65c43f-47d6-43cc-b4b1-a51a679ba41d';
                break;
            case 'PARTIALLY_VACANT':
                uuid = 'd025c017-7d45-4049-8ab9-202ba97dccaa';
                break;
            case 'PARTIALLY_OCCUPATION':
                uuid = '85549513-4a81-4009-8dc0-f3e742f91cd9';
                break;
            case 'NO_VACANT':
                uuid = 'f07a769a-e649-4388-a8f4-2a94b9d055cd';
                break;
            default:
                break;
        }
        if (uuid) {
            window.LHBbigdata.send({
                event_id: uuid
            });
        }
        this.updateParamsStore({
            occupationStatus: val,
        });
        this.loadData();
    };
    Search.prototype.shopChangeHandle = function () {
        this.loadData();
    };
    Search.prototype.addHandle = function () {
        window.LHBbigdata.send({
            event_id: '0d750a70-c39e-4da5-9306-d34d66366f4d'
        });
        this.$emit('showModal');
        this.$refs.addClueModal.init();
    };
    // 日期切换
    Search.prototype.dateRangeChange = function (val, pattern) {
        console.log("val: any, pattern: any = ", val, pattern);
        if (+pattern === 3) {
            this.searchParams.period = 'YEAR';
            this.searchParams.year = val[0];
            this.searchParams.startDate = '';
            this.searchParams.endDate = '';
        }
        else if (+pattern === 4) {
            this.searchParams.period = 'MONTH';
            this.searchParams.year = '';
            this.searchParams.startDate = val[0];
            this.searchParams.endDate = val[1];
        }
        else {
            this.searchParams.period = 'DAY';
            this.searchParams.year = '';
            this.searchParams.startDate = val[0];
            this.searchParams.endDate = val[1];
        }
        this.pattern = pattern;
        this.updateParamsStore({
            pattern: pattern,
        });
        this.loadData();
    };
    Search.prototype.handleCommand = function (command) {
        var event_id = '705eb5e9-04db-45ab-9a0d-366bbb45c81d';
        switch (command) {
            case 'alert':
                event_id = '705eb5e9-04db-45ab-9a0d-366bbb45c81d';
                break;
            case 'export':
                event_id = '7e84a269-175f-4aa6-a98a-0fff5c6bdcbc';
                break;
            case 'share':
                event_id = 'ae7bddf0-63c4-43b4-b0aa-1b1b9ef2eba1';
                break;
        }
        window.LHBbigdata.send({ event_id: event_id });
        this.$emit(command);
    };
    Search.prototype.searchSubmit = function (val) {
        var params = this.searchParams;
        this.searchParams = __assign(__assign({}, params), val);
        this.updateParamsStore(__assign({}, val));
        this.loadData();
    };
    __decorate([
        Prop({ type: Number, default: 0 })
    ], Search.prototype, "alertNum", void 0);
    __decorate([
        Watch('user', {
            deep: true,
            immediate: false
        })
    ], Search.prototype, "companyChange", null);
    Search = __decorate([
        Component({
            components: {
                StatusSelect: StatusSelect,
                OccupySelect: OccupySelect,
                ShopSelect: ShopSelect,
                CategorySelect: CategorySelect,
                TagSelect: TagSelect,
                CitySelect: CitySelect,
                Button: Button,
                DateRange: DateRange,
                AddClueModal: AddClueModal,
                SpotSelect: SpotSelect,
                SupplierSelect: SupplierSelect,
                MetroLineSelect: MetroLineSelect
            },
        })
    ], Search);
    return Search;
}(Vue));
export default Search;
